import { ResultValues } from '@getnuvo/importer-react'
import {
  UniversalImporterValueObjectsImportTypeEnum,
  UniversalImporterImportProcessMetadataInput,
} from 'generated/resources/datatable.graphql'

import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'
import { apiClient } from 'modules/core/lib/mobx-rest'

const UNIVERSAL_IMPORTER_ENDPOINT = '/universal_importer/import_processes'

interface Props {
  data: ResultValues
  companyId: string
  importType: UniversalImporterValueObjectsImportTypeEnum
  metadata?: UniversalImporterImportProcessMetadataInput[]
  parentProcessId?: string | null
  rootProcessId?: string | null
  isEdition: boolean
  originalFile?: File
}

export const useSendImportResults = () => {
  const api = apiClient()
  const { performAction: sendImportResults } = useAsyncAction(
    async ({
      data,
      metadata,
      companyId,
      importType,
      parentProcessId,
      rootProcessId,
      isEdition,
      originalFile,
    }: Props) => {
      if (originalFile) {
        const formData = new FormData()

        formData.append('data', JSON.stringify(data))
        formData.append('company_id', companyId.toString())
        formData.append('import_type', importType)
        formData.append('is_edition', isEdition.toString())

        if (metadata) {
          formData.append('metadata', JSON.stringify(metadata))
        }
        if (parentProcessId) {
          formData.append('parent_process_id', parentProcessId.toString())
        }
        if (rootProcessId) {
          formData.append('root_process_id', rootProcessId.toString())
        }
        formData.append('original_file', originalFile)

        const response = await api.post(UNIVERSAL_IMPORTER_ENDPOINT, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        return response
      } else {
        const response = await api.post(UNIVERSAL_IMPORTER_ENDPOINT, {
          data,
          metadata,
          company_id: companyId,
          import_type: importType,
          parent_process_id: parentProcessId,
          root_process_id: rootProcessId,
          is_edition: isEdition,
        })
        return response
      }
    },
    {
      successMessage: i18n.t('universal_importer.nuvo_importer.results.success_alert'),
    }
  )

  return { sendImportResults }
}
